module.exports = __webpack_public_path__ + "static/img_18-feb013340ba9e0c689db3c0975b71101.png";